module.exports = __webpack_public_path__ + "img/chain.922021b9.jpg";